<html>

<head>
  <script src="<%= process.env.ENVJS %>"></script>
</head>

</html>
